import { render, staticRenderFns } from "./OfferUpdatedPricingChat.vue?vue&type=template&id=d5c0cb08&"
import script from "./OfferUpdatedPricingChat.vue?vue&type=script&lang=js&"
export * from "./OfferUpdatedPricingChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports